import * as React from "react"
import { LocalErrorBoundary } from "@digits-shared/components/Error/LocalErrorBoundary"
import { useDeveloperTools } from "src/shared/components/DeveloperTools/useDeveloperTools"

export const DeveloperToolsGate: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { enabled } = useDeveloperTools()
  if (!enabled) return null

  return (
    <LocalErrorBoundary fallback={null}>
      <React.Suspense fallback={null}>{children}</React.Suspense>
    </LocalErrorBoundary>
  )
}
